import React, { useContext } from 'react'
import {
    useLocation,
    useParams,
    useNavigate,
    useRoutes,
    UNSAFE_NavigationContext,
    useSearchParams,
} from 'react-router-dom'
import * as commonCode from 'app/shared/config/commonCode'
import * as commonMsg from 'app/shared/config/commonMsg'
import {
    getDeviceType,
    isMobileDevice,
    isRealApp,
    isTabletDevice,
    isNull,
} from 'app/shared/utils/comUtil'
import { BasePage } from 'app/shared/components/base/BasePage'
import {
    useLazySelectCom0204Query,
    useLazySelectCom0206Query,
} from 'app/core/services/com/com.service'
import { setCusInfoArr } from 'app/core/slices/user/user.slice'
import { setProductMainArr } from 'app/core/slices/product/productMain.slice'
import { setJoinProductArr } from 'app/core/slices/product/joinProduct.slice'
import { useDispatch } from 'react-redux'
import { useAppSelector } from 'app/core/hooks'

import { CommonUIContext, useProgressDialog } from '../context/CommonUIProvider'
import { showAlert, showConfirm } from 'app/shared/utils/util'
import { Com0102CtlUrlOut } from 'app/core/models/api/com/com0102'
import { useCommonCode } from './util/commonCode.hook'
import moment from 'moment'
import { selectorMenuDic } from 'app/core/slices/user/menu.slice'

export interface Verification {
    mobileAuthOnly: boolean
    prevPage: string
    nextPage: string
    etcStsYn?: boolean
}

const useBasePage = () => {
    const uiContext = useContext(CommonUIContext)
    const [com0204, com0204State] = useLazySelectCom0204Query()
    const { fetchCommonCode } = useCommonCode({
        fetchOnLoad: false,
        cdgpId: 'MENU_CTRL_ATRB',
        dsrnTgtBacd: '110',
    })

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const routerContext = useContext(UNSAFE_NavigationContext)
    const { show: showLoadingDialog, hide: hideLoadingDialog } =
        useProgressDialog()
    const params = useParams()
    const queryParam = params
    const menuDic = useAppSelector(selectorMenuDic) ?? []
    const location = useLocation()
    const pathname = location.pathname
    const curLocation = location.pathname.split('/')
    const isRegister: boolean = curLocation[3] === 'register'
    const vAcd = useAppSelector((state) => state.user.cusInfo.alplDcd)
    const vjoinProduct = useAppSelector((state) => state.joinProduct)
    const paramId = params.id
    const v3LoadCheck = React.useRef(false)
    const [searchParams] = useSearchParams()
    //
    const goPage = async (url: string) => {
        if (url === '/') {
            goHome()
            return
        }
        goPageWithData(url, {})
    }
    const goPageWithData = (url: string, data: object) => {
        validMenu(url, () =>
            navigate(url, { state: Object.assign(data, { goPage: true }) })
        )
    }

    const replacePage = (url: string, goBack?: boolean) => {
        replacePageWithData(url, { goBack: goBack ?? false })
    }
    const replacePageWithData = (url: string, data: object) => {
        validMenu(url, () =>
            navigate(url, {
                replace: true,
                state: Object.assign(data ?? {}, { goPage: true }),
            })
        )
    }

    const goBack = () => {
        navigate(-1)
    }

    const validMenu: (url: string, callback: () => void) => void = async (
        url: string,
        callback: () => void
    ) => {
        const validMenuInfo = await getMenuValidInfo(url)

        if (validMenuInfo) {
            if (validMenuInfo.isControl) {
                showAlert({
                    msg: validMenuInfo.alertMsg,
                    onConfirm: () => {
                        if (validMenuInfo.isEnterPos) {
                            callback()
                        } else {
                            if (window.location.pathname === '/gw') {
                                goHome()
                            }
                        }
                    },
                })
                return
            }
        }
        callback()
    }

    const getMenuValidInfo = async (url: string) => {
        const commonCodeFetch = await fetchCommonCode()
        if (commonCodeFetch.isSuccess) {
            /** *
                [
                    {
                        "cdgpId": "MENU_CTRL_ATRB",
                        "ccddId": "M0012",                      >> 메뉴Id
                        "cdNm": "신용카드",
                        "descCon": "",          > 메뉴DICT 뒤져서 실제경로 가져오기
                        "expuSqc": 5,
                        "prnsId": "",
                        "cdAtrbEtc1Con": "Y",                   >> 제어여부  
                        "cdAtrbEtc2Con": "Y",                   >> 진입여부  // 진입가능
                        "cdAtrbEtc3Con": "20250909010000",      >> 제어시작일시
                        "cdAtrbEtc4Con": "20251009235900",      >> 제어종료일시
                        "cdAtrbEtc5Con": "9/9~10/09 까지 제어 메세지노출중. "   >> alert메세지
                    },
                ]
             */

            const menuCtrlAtrb = structuredClone(
                commonCodeFetch.data
            ) as unknown as Com0102CtlUrlOut

            menuCtrlAtrb.data.forEach((x) => {
                x['descCon'] = menuDic[x.ccddId]?.menuUrlAdr ?? ''
            })

            //MenuId가 같거나 실제경로가 같은 경우 체크시작
            const targetItem = menuCtrlAtrb.data.find(
                (x) =>
                    x.ccddId === url.replace('/', '') || url.includes(x.descCon)
            )

            if (targetItem) {
                const isControl = targetItem.cdAtrbEtc1Con === 'Y' //제어여부
                const isEnterPos = targetItem.cdAtrbEtc2Con === 'Y' //진입여부  // 진입가능
                const startDate = targetItem.cdAtrbEtc3Con //제어시작일시
                const endDate = targetItem.cdAtrbEtc4Con //제어종료일시
                const alertMsg = targetItem.cdAtrbEtc5Con //alert메세지

                //제어여부=Y AND 제어시작일시,종료일시에 포함된 경우, 제어동작.

                if (isControl && startDate && endDate) {
                    const now = moment()
                    if (
                        now.isBetween(
                            moment(startDate, 'YYYYMMDDHHmmss'),
                            moment(endDate, 'YYYYMMDDHHmmss'),
                            'seconds',
                            '[]'
                        )
                    ) {
                        return {
                            isControl: isControl,
                            isEnterPos: isEnterPos,
                            alertMsg: alertMsg,
                        }
                    }
                }
            }

            return {
                isControl: false,
                isEnterPos: false,
                alertMsg: '',
            }
        }
    }

    const isBack = React.useMemo(() => {
        return (
            routerContext?.navigator['action'] === 'POP' ||
            location.state?.['goBack'] === true
        )
    }, [])

    //

    const deviceType = getDeviceType()
    const [fetch0206] = useLazySelectCom0206Query() // 안랩 V3 제품번호를 암호화해서 전달
    const fetch0206Data = React.useRef(null)

    /**
     * 홈으로 이동
     */
    const goHome = (force?: boolean) => {
        if (force === true) {
            replacePage('/')
            return
        }

        if (
            vAcd === '01' ||
            (searchParams?.get('acd') === '01' &&
                (searchParams?.get('mrknCretBrcd') ||
                    searchParams?.get('mrknCretEmn')))
        ) {
            replacePage('/mai/bob/MAIBOB0101')
        } else {
            replacePage('/')
        }
    }
    /**
     * 상품몰로 이동
     */
    const goProductMall = (replace?: boolean) => {
        const catlDcd =
            menuDic['M0002']?.menuUrlAdr?.split('?')[1]?.split('=')[1] ?? '103'

        dispatch(
            setProductMainArr([
                { key: 'catlDcd', value: catlDcd },
                { key: 'sortNam', value: '추천순' },
                { key: 'tabviewAllYn', value: false },
            ])
        )

        replace === true ? replacePage('/M0002') : goPage('/M0002')
        // navigate('/M0002', {
        //     replace: replace ?? false,
        //     state: { goPage: true },
        // })
    }

    /** 비대면 실명 확인 시작 */
    const startVerification = async (option?: Verification) => {
        /**
         * 간편인증도입으로 본인인증 수단 선택 화면으로 이동
         * as-is : targetUrl = '/com/ath/COMATH0102' (휴대폰 본인인증)
         * to-be : targetUrl = '/com/ath/COMATH0105' (본인인증 수단 선택)
         */
        let targetUrl = '/com/ath/COMATH0105'

        if (getDeviceType() === 'W' || !isMobileDevice() || isTabletDevice()) {
            uiContext.openMobileGuide()
        } else {
            /** =============================================================
             * 세션 체크해서 휴대폰본인인증을 했던 사용자면 신분증부터 시작함
             ================================================================  */
            const com0204Result = await com0204() // 세션체크

            if (com0204Result.isSuccess) {
                //휴대폰인증 완료 - 1 / 신분증인증 완료 - 2 / 안면인증 OR 계좌인증완료 - 3
                if (Number(com0204Result.data.authStep) >= 1) {
                    targetUrl = '/com/ath/COMATH0103'
                }

                /** =============================================================
                 * 비대면실명확인 전 유량제어 체크
                 ================================================================  */
                startNetFunnel(() => {
                    goPageWithData(targetUrl, option)
                })
            }
        }
    }

    /** 비대면 실명 확인 시작 >모임 서비스는 브릿지 페이지가 달라 새로 생성함. */
    const startMoimVerification = async (option?: Verification) => {
        /**
         * 간편인증도입으로 본인인증 수단 선택 화면으로 이동
         * as-is : targetUrl = '/com/ath/COMATH0102' (휴대폰 본인인증)
         * to-be : targetUrl = '/com/ath/COMATH0105' (본인인증 수단 선택)
         */
        let targetUrl = '/com/ath/COMATH0105'

        if (getDeviceType() === 'W' || !isMobileDevice() || isTabletDevice()) {
            uiContext.openMobileGuide()
        } else {
            /** =============================================================
             * 세션 체크해서 휴대폰본인인증을 했던 사용자면 신분증부터 시작함
             ================================================================  */
            const com0204Result = await com0204() // 세션체크

            if (com0204Result.isSuccess) {
                //휴대폰인증 완료 - 1 / 신분증인증 완료 - 2 / 안면인증 OR 계좌인증완료 - 3
                if (Number(com0204Result.data.authStep) >= 1) {
                    targetUrl = '/prd/tgr/PRDTGR0202'
                }

                /** =============================================================
                 * 비대면실명확인 전 유량제어 체크
                 ================================================================  */
                startNetFunnel(() => {
                    goPageWithData(targetUrl, option)
                })
            }
        }
    }

    /**
     * V3실행 콜백 함수 정의
     */
    const v3CallBackLoad = () => {
        globalThis._callback_ahnlab_rc = function () {}

        // 콜백 함수 등록
        globalThis._callback_ahnlab = function (res_code, res_dtl) {
            // 실패 케이스
            if (res_code !== 200) {
                switch (res_dtl) {
                    case 70:
                    case 71:
                    case 72:
                    case 73:
                    default:
                        break
                }
                return
            }

            // 성공 케이스
            if (res_dtl === 0) {
                mplStart()
                return
            }

            switch (res_dtl) {
                case 83:
                    if (isRealApp() && (vAcd === '01' || vAcd === '03')) {
                        if (
                            window.location.protocol === 'https:' &&
                            deviceType === 'A'
                        ) {
                            if (!vjoinProduct.v3LoadCheck) {
                                showConfirm({
                                    msg: 'IBK 모바일브랜치를 이용하려면V3 백신 앱이 필요합니다.지금 설치하시겠어요?',
                                    onConfirm: () => {
                                        mplStart()
                                    },
                                    onCancel: () => {
                                        goHome()
                                    },
                                    confirmLabel: '예',
                                    cancelLabel: '아니요',
                                })
                            } else {
                                dispatch(
                                    setJoinProductArr([
                                        { key: 'v3LoadCheck', value: false },
                                    ])
                                )
                            }
                        }
                    } else {
                        if (
                            window.location.protocol === 'https:' &&
                            deviceType === 'A'
                        ) {
                            if (!vjoinProduct.v3LoadCheck) {
                                showConfirm({
                                    msg: 'IBK 모바일브랜치를 이용하려면V3 백신 앱이 필요합니다.지금 설치하시겠어요?',
                                    onConfirm: () => {
                                        mplStart()
                                    },
                                    onCancel: () => {
                                        goHome()
                                    },
                                    confirmLabel: '예',
                                    cancelLabel: '아니요',
                                })
                            } else {
                                dispatch(
                                    setJoinProductArr([
                                        { key: 'v3LoadCheck', value: false },
                                    ])
                                )
                            }
                        }
                    }
                case 99:
                default:
                    break
            }
        }
    }

    /*
     *    V3 실행 필요한 page에서 실행
     */
    const runV3 = async () => {
        v3CallBackLoad()
        // 운영서비스
        if (isRealApp() && (vAcd === '01' || vAcd === '03')) {
            if (window.location.protocol === 'https:' && deviceType === 'A') {
                mplStart()
            }
        } else {
            if (window.location.protocol === 'https:' && deviceType === 'A') {
                mplStart()
            }
        }
    }

    /**
     * V3기동
     */
    const mplStart = async () => {
        fetch0206Data.current = await fetch0206()

        await globalThis.mpl_start(
            fetch0206Data.current?.data.license,
            fetch0206Data.current?.data.time,
            '1',
            10
        )
    }

    /**
     * V3Load
     */
    const runV3Load = async () => {
        globalThis._callback_ahnlab = function () {}
        if (isRealApp() && (vAcd === '01' || vAcd === '03')) {
            if (window.location.protocol === 'https:' && deviceType === 'A') {
                const TK = await globalThis.mpl_token()
                const CD = await globalThis.mpl_enc_param()

                dispatch(
                    setJoinProductArr([{ key: 'v3LoadCheck', value: true }])
                )
                await globalThis.mpl_load(TK, CD)
            }
        } else {
            if (window.location.protocol === 'https:' && deviceType === 'A') {
                const TK = await globalThis.mpl_token()
                const CD = await globalThis.mpl_enc_param()

                dispatch(
                    setJoinProductArr([{ key: 'v3LoadCheck', value: true }])
                )
                await globalThis.mpl_load(TK, CD)
            }
        }
    }

    /*
     *     고객추적
     *     wcslog.js script 필요한 page에서 실행
     */

    const runNaver = async () => {
        if (isRealApp()) {
            if (globalThis.wcs) {
                if (!globalThis.wcs_add) globalThis.wcs_add = {}

                // (2) 각 사이트별 식별자 설정
                globalThis.wcs_add['wa'] = 's_1d3ef2b2641c' // 사이트 식별자 (=네이버공통키, na_account_id)

                // (3) 광고 전환추적을 위한 cookie domain설정
                await globalThis.wcs.inflow('mbranch.ibk.co.kr')

                // 아래 Script는 개별 이벤트 발생시 로그를 전송하기 위한 구역. 결제 완료 페이지이므로, PV 이벤트 와 결제완료 전환 이벤트를 전송함

                // (4) PV 이벤트 전송
                await globalThis.wcs_do()

                // (5) 전환이벤트 전송, (예) 신청완료 이벤트 전송
                globalThis._conv = {} // 전환이벤트 정보 담을 object 생성
                globalThis._conv = { type: 'lead' } // 전환이벤트의 종류 설정
                await globalThis.wcs.trans(globalThis._conv) // 전환이벤트 정보를 담은 object를 서버에 전송
            }
        } else {
            // 개발
            return
        }
    }

    /*
     *   카카오
     *   kp.js script 필요한 page에서 실행
     */

    const runKakao = async () => {
        if (isRealApp()) {
            await globalThis.kakaoPixel?.('827458633664776210').pageView()
            await globalThis.kakaoPixel?.('827458633664776210').signUp()
        }
    }

    /*
     *   CPA
     *   nsttrack.min.js script 필요한 page에서 실행
     */

    const runCPA = async () => {
        if (isRealApp()) {
            await globalThis.NSTATION?.SCRIPT.conv()
        }
    }

    // 유량제어
    const runNetFunnel = async (url: string, menuId: string) => {
        if (
            menuId === 'M0008' ||
            menuId === 'M0009' ||
            menuId === 'M0010' ||
            menuId === 'M0011'
        ) {
            if (
                window.location.protocol === 'https:' &&
                globalThis.nfStartSection
            ) {
                let segKey = ''
                if (menuId === 'M0008') segKey = 'dep103_segSection'
                else if (menuId === 'M0009') segKey = 'dep101_segSection'
                else if (menuId === 'M0010') segKey = 'dep102_segSection'
                else segKey = 'crd302_segSection'

                showLoadingDialog()
                // 유량제어 실행
                await globalThis.nfStartSection(
                    { projectKey: 'service_4', segmentKey: segKey },
                    function (response) {
                        hideLoadingDialog()

                        if (
                            response.status === 'Success' ||
                            response.status === 'Bypass' ||
                            response.status === 'Block' ||
                            response.status === 'NetworkError' ||
                            response.status === 'Error'
                        ) {
                            dispatch(
                                setCusInfoArr([{ key: 'nfCheck', value: true }])
                            )
                            dispatch(
                                setCusInfoArr([
                                    { key: 'nfSegKey', value: segKey },
                                ])
                            )

                            if (menuId === 'M0008') {
                                dispatch(
                                    setProductMainArr([
                                        { key: 'catlDcd', value: '103' },
                                        { key: 'sortNam', value: '추천순' },
                                        { key: 'tabviewAllYn', value: false },
                                    ])
                                )
                            } else if (menuId === 'M0009') {
                                dispatch(
                                    setProductMainArr([
                                        { key: 'catlDcd', value: '101' },
                                        { key: 'sortNam', value: '추천순' },
                                        { key: 'tabviewAllYn', value: false },
                                    ])
                                )
                            } else if (menuId === 'M0010') {
                                dispatch(
                                    setProductMainArr([
                                        { key: 'catlDcd', value: '102' },
                                        { key: 'sortNam', value: '추천순' },
                                        { key: 'tabviewAllYn', value: false },
                                    ])
                                )
                            } else if (menuId === 'M0011') {
                                dispatch(
                                    setProductMainArr([
                                        { key: 'catlDcd', value: '302' },
                                        { key: 'sortNam', value: '추천순' },
                                        { key: 'tabviewAllYn', value: false },
                                    ])
                                )
                            }
                            goPage('/' + menuId)
                        } else if (response.status === 'Close') {
                        }
                    }
                )
            } else {
                if (menuId === 'M0008') {
                    dispatch(
                        setProductMainArr([
                            { key: 'catlDcd', value: '103' },
                            { key: 'sortNam', value: '추천순' },
                            { key: 'tabviewAllYn', value: false },
                        ])
                    )
                } else if (menuId === 'M0009') {
                    dispatch(
                        setProductMainArr([
                            { key: 'catlDcd', value: '101' },
                            { key: 'sortNam', value: '추천순' },
                            { key: 'tabviewAllYn', value: false },
                        ])
                    )
                } else if (menuId === 'M0010') {
                    dispatch(
                        setProductMainArr([
                            { key: 'catlDcd', value: '102' },
                            { key: 'sortNam', value: '추천순' },
                            { key: 'tabviewAllYn', value: false },
                        ])
                    )
                } else if (menuId === 'M0011') {
                    dispatch(
                        setProductMainArr([
                            { key: 'catlDcd', value: '302' },
                            { key: 'sortNam', value: '추천순' },
                            { key: 'tabviewAllYn', value: false },
                        ])
                    )
                }
                goPage('/' + menuId)
            }
        } else {
            if (menuId === 'M0012') {
                dispatch(
                    setProductMainArr([
                        { key: 'catlDcd', value: '301' },
                        { key: 'sortNam', value: '추천순' },
                        { key: 'tabviewAllYn', value: false },
                    ])
                )
            } else if (menuId === 'M0013') {
                dispatch(
                    setProductMainArr([
                        { key: 'catlDcd', value: '600' },
                        { key: 'sortNam', value: '추천순' },
                        { key: 'tabviewAllYn', value: false },
                    ])
                )
            } else if (menuId === 'M0014') {
                dispatch(
                    setProductMainArr([
                        { key: 'catlDcd', value: '400' },
                        { key: 'sortNam', value: '추천순' },
                        { key: 'tabviewAllYn', value: false },
                    ])
                )
            } else if (menuId === 'M0015') {
                dispatch(
                    setProductMainArr([
                        { key: 'catlDcd', value: 'A00' },
                        { key: 'sortNam', value: '추천순' },
                        { key: 'tabviewAllYn', value: false },
                    ])
                )
            } else if (menuId === 'M0016') {
                dispatch(
                    setProductMainArr([
                        { key: 'catlDcd', value: '800' },
                        { key: 'sortNam', value: '추천순' },
                        { key: 'tabviewAllYn', value: false },
                    ])
                )
            } else if (menuId === 'M0017') {
                dispatch(
                    setProductMainArr([
                        { key: 'catlDcd', value: '500' },
                        { key: 'sortNam', value: '추천순' },
                        { key: 'tabviewAllYn', value: false },
                    ])
                )
            }

            if (url === '/etc/sts/ETCSTS0101') {
                startVerification({
                    mobileAuthOnly: true,
                    prevPage: pathname,
                    nextPage: url,
                    etcStsYn: true,
                })
            } else if (
                url === '/etc/not/ETCNOT0201' &&
                pathname === '/mai/bob/MAIBOB0101'
            ) {
                // 공지사항
                goPage(url)
            } else if (pathname === url.split('?')[0]) {
                replacePage(url)
            } else {
                goPage('/' + menuId)
            }
        }
    }

    // 상품별 유량제어
    const startNetFunnel = async (callbackFunction: () => void) => {
        if (
            window.location.protocol === 'https:' &&
            globalThis.nfStartSection
        ) {
            showLoadingDialog()
            // 유량제어 실행
            await globalThis.nfStartSection(
                { projectKey: 'service_4', segmentKey: 'segSection' },
                function (response) {
                    hideLoadingDialog()

                    //
                    if (
                        response.status === 'Success' ||
                        response.status === 'Bypass' ||
                        response.status === 'Block' ||
                        response.status === 'NetworkError' ||
                        response.status === 'Error'
                    ) {
                        // 다음페이지 로직
                        dispatch(
                            setCusInfoArr([{ key: 'nfCheck', value: true }])
                        )
                        callbackFunction()
                    } else if (response.status === 'Close') {
                    }
                }
            )
        } else {
            dispatch(setCusInfoArr([{ key: 'nfCheck', value: true }]))
            callbackFunction()
        }
    }

    // 유량제어 멈춤
    const stopNetFunnel = () => {
        if (window.location.protocol === 'https:' && globalThis.nfStopSection) {
            showLoadingDialog()
            globalThis.nfStopSection(
                { projectKey: 'service_4', segmentKey: 'segSection' },
                function (response) {
                    dispatch(setCusInfoArr([{ key: 'nfCheck', value: false }]))
                    hideLoadingDialog()
                }
            )
        }
    }

    // 상품별 유량제어 멈춤
    const stopSegKeyNetFunnel = (segKey: string) => {
        if (window.location.protocol === 'https:' && globalThis.nfStopSection) {
            showLoadingDialog()
            globalThis.nfStopSection(
                { projectKey: 'service_4', segmentKey: segKey },
                function (response) {
                    dispatch(setCusInfoArr([{ key: 'nfCheck', value: false }]))
                    dispatch(setCusInfoArr([{ key: 'nfSegKey', value: '' }]))
                    hideLoadingDialog()
                }
            )
        }
    }

    return {
        queryParam,
        paramId,
        isRegister,
        location,
        curLocation,
        pathname,
        commonCode,
        commonMsg,
        params,
        isBack,
        goPage,
        replacePage,
        goBack,
        goPageWithData,
        replacePageWithData,
        goProductMall,
        startVerification,
        startMoimVerification,
        BasePage,
        goHome,
        runV3,
        runV3Load,
        runNaver,
        runKakao,
        runCPA,
        runNetFunnel,
        stopNetFunnel,
        stopSegKeyNetFunnel,
        getMenuValidInfo,
    }
}

export default useBasePage
